import React from "react";

export const PinId = ({ value }) => {
    if (value){
        return (<a 
            target='_blank' 
            rel='noopener noreferrer' 
            href={`${window.hostName.OUTAGE_PIN_URL}${value}`}
        >
            {value}
        </a>)
    }

    return null
    
}